<template>
    <div class="news-block__cards-filter" v-if="options.length != 0">
        <select @change="$emit('update', { attribute: attribute, value: selected })" v-model="selected">
            <option value="">{{ title }}</option>
            <option v-for="(option, index) in options" :key="`${index}-option`" :value="option.value">{{ option.label }}</option>
        </select>
        <i class="icon-chevron-down"></i>
    </div>
</template>

<script>

export default {
    props: ["attribute", "title", "options", "value"],
    data() {
        return {
            selected: ""
        }
    },
    watch: {
        value: function () {
            if (this.value != undefined) {
            this.selected = this.value; 
        } else {
                this.selected = ""; 
            }
        }
    },
    mounted() {
        if (this.value != undefined) {
            this.selected = this.value;
        }
    }
}
</script>

